import React from "react";
import { Row, Col, Tooltip } from "antd";
import { Info } from "@material-ui/icons";
import { dirname } from "util/resourcePath";
import { file } from "jszip";

const directory = dirname();

export const ftCostPDFUploadConfig = {
  modal: {
    title: () => (
      <>
        FT Cost PDF Upload Instructions{"  "}
      </>
    ),
    content: () => (
      <>
        <p>
          Please upload the latest FT Cost PDF file for each quarter in this upload section.
          You could download FT cost PDF from MEA/PEA official website.
        </p>
        <p>
          The system will automatically use the uploaded FT Cost PDF to send invoice email to our clients in invoice table.
        </p>
        <p>
          Example of FT Cost PDF file looks like the following image
        </p>
        <img
          src={`${directory}/images/upload_data_page/ft-cost-pdf-example.png`}
          alt="FT Cost PDF Example"
          style={{ maxWidth: "80%", border: "1px solid #ccc", padding: "10px", display: "block", margin: "0 auto" }}
        />
      </>
    ),
  },
  form: {
    title: "FT Cost PDF Upload",
    description: "Upload the FT Cost PDF file here for invoice email sending from invoicing table.",
    upload: {
      uploadUrl: "/invoice/ft_cost_pdf_upload",
      maxCount: 1,
      accept: ".pdf",
      isInvalid: (file) => {
        // Check file extension
        const fileName = file.name.toLowerCase();
        const isPDF = fileName.endsWith(".pdf");

        if (!isPDF) {
          return "You can only upload PDF files!";
        }

        // Check file type
        const isValidType =
          file.type === "application/pdf" ||
          file.type === "application/x-pdf" ||
          file.type === "" || // some browsers/clients omit MIME type
          file.name.toLowerCase().endsWith(".pdf");

        if (!isValidType) {
          return "Invalid file type. Please upload a PDF file.";
        }

        // Check file size (5MB limit)
        const isLt5M = file.size / 1024 / 1024 < 5;
        if (!isLt5M) {
          return "File must be smaller than 5MB!";
        }
      }
    }
  }
}